import React from "react";

import { useHistory } from "react-router-dom";

const AmenityCard = ({ title, description, image, route }) => {
  const history = useHistory();

  const handleMoreClick = () => {
    history.push(route);
  };

  return (
    <div className="amenity-card">
      <div className="amenity-img">
        <img
          style={{ width: "240px", height: "180px" }}
          src={image}
          alt=""
          onClick={handleMoreClick}
        />
      </div>
      <div className="amenity-details">
        <h3 style={{color:"#211551",fontSize:"16px"}} className="titlesFontFamily">{title}</h3>
        <p style={{color:"darkslategrey",fontWeight:500,fontSize:"13px"}}>{description}</p>
        <button
          onClick={handleMoreClick}
          className="btn"
          style={{ cursor: "pointer", textTransform: "capitalize" }}
        >
          view more
        </button>
      </div>
    </div>
  );
};

export default AmenityCard;
